module.exports = __webpack_public_path__ + "assets/img/4_88_big.f893a58e.jpg";